import { isNonEmptyArray } from '@/helpers/array-helpers'
import dayjs from '@/services/date'

/**
 * @class
 * @public
 */
export default class BookingBlockViewModel {
  constructor({ locationId, datesLocal = [], messageMarkDown = '' } = {}) {
    /**
     * @type {Number}
     */
    this.locationId = Number(locationId)
    /**
     * @type {Array<Date>}
     */
    this.datesLocal = isNonEmptyArray(datesLocal)
      ? datesLocal.map((date) => dayjs(date))
      : []
    /**
     * Mark down text to be displayed to the user
     * @type {String}
     */
    this.messageMarkDown = messageMarkDown
  }
}
